var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 24.1870968c0 4.5645161-3.1770492 7.8129032-7.8688525 7.8129032-4.4983606 0-8.1311475-3.5741935-8.1311475-8s3.6327869-8 8.1311475-8c2.190164 0 4.0327869.7903226 5.4524591 2.0935484l-2.2131148 2.0935484c-2.895082-2.7483871-8.2786885-.683871-8.2786885 3.8129032 0 2.7903226 2.2655737 5.0516129 5.0393442 5.0516129 3.2196722 0 4.4262295-2.2709677 4.6163935-3.4483871h-4.6163935v-2.7516129h7.7409836c.0754099.4096774.1278689.8032258.1278689 1.3354839z",
    fill: "#fff",
    fillRule: "evenodd",
    transform: "translate(-14 -16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.dfcd99e8.svg";
export { ForwardRef as ReactComponent };